import { Component, Input } from "@angular/core";
import { Administre } from "../../../interfaces/Administre";

@Component({
  selector: "app-informations",
  templateUrl: "./informations.component.html",
  standalone: false,
})
export class InformationsComponent {
  @Input() administre: Administre;
}
